<script setup lang="ts">
const route = useRoute()
const config = useRuntimeConfig()
const { t } = useI18n()
const localePath = useLocalePath()

const { navLinks } = useNavLinks()

// Get the page data from the route.path
const pageData = computed(() => {
  return (
    navLinks.value?.find(
      (link) => link.to.replace(/^\//, '') === route.path.replace(/^\//, '')
    ) ?? null
  )
})

useSeoMeta({
  title: () => pageData?.value?.label + ' - ' + t('app.title'),
  description: () => pageData?.value?.description,
  ogTitle: () => pageData?.value?.label + ' - ' + t('app.title'),
  ogImage: () => pageData?.value?.cover,
  ogUrl: () => config.public.baseUrl + route.path,
  ogDescription: () => pageData?.value?.description,
  twitterTitle: () => pageData?.value?.label + ' - ' + t('app.title'),
  twitterImage: () => pageData?.value?.cover,
  twitterDescription: () => pageData?.value?.description,
  twitterCard: () => 'summary_large_image',
})
</script>

<template>
  <UContainer class="pb-8 sm:pb-16">
    <UBreadcrumb
      :links="[
        { label: '', to: localePath('/'), icon: 'i-tabler-home' },
        {
          label: pageData?.label ?? '',
        },
      ]"
    />
    <UPageHero
      :icon="pageData?.icon ?? ''"
      :title="pageData?.label ?? ''"
      :description="pageData?.description ?? ''"
      align="center"
    >
      <img
        v-if="pageData?.cover"
        :src="pageData.cover"
        :alt="pageData.alt"
        class="w-full sm:w-[600px] rounded-xl shadow-md mx-auto"
      />
      <template #description>
        <MDC
          v-if="pageData?.description"
          :value="pageData.description"
          class="prose prose-primary dark:prose-invert max-w-3xl text-md sm:text-lg"
        />
      </template>
    </UPageHero>

    <UPage>
      <UPageGrid>
        <ULandingCard
          v-for="item in pageData?.children ?? []"
          :key="item.id"
          v-bind="item"
        >
          <template #description>
            <span class="line-clamp-2">{{ item.description }}</span>
          </template>
        </ULandingCard>
      </UPageGrid>
    </UPage>
  </UContainer>
</template>

<style scoped></style>
